import IEditVehicleRequestModel from "interfaces/Request/IEditVehicleRequestModel";
import { GlobalState } from "little-state-machine";

export const updateEditVehicleRequest = (
  state: GlobalState,
  editVehicleRequest: IEditVehicleRequestModel
) => ({
  ...state,
  editVehicleRequest
});
